module.exports = __webpack_public_path__ + "img/10.31363b1d.jpg";